//引荐计划相关接口
import request from "../api/request";
import utils from "../../utils/index";
import pfile from "@/utils/secretkey/pfile";
import sfile from "@/utils/secretkey/sfile";
var ak = utils.genak();
var ed = utils.re(ak, unescape(pfile)); //秘钥
function decrypt(data) {
    if (data?.ak) {
        let plaintext = utils.rd(data.ak, unescape(sfile));
        let obj = utils.secret(data.ed, plaintext, true);
        return JSON.parse(obj);
    } else {
        return data;
    }
}
function inParameter(data) {
    if (data) {
        return { sn: ed, jt: utils.secret(data, ak) };
    } else {
        return data;
    }
}
//短链图表
export function getViewsChart(data) {
  return request({
      url: "/short_url/getViewsChart",
      method: "post",
      data: inParameter(data),
  })
      .then((res) => {
          res.data = decrypt(res.data);
          return res;
      })
      .catch((err) => {
          console.log(err);
      });
}

//短链数据概览
export function getDataOverview(data) {
  return request({
      url: "/short_url/getDataOverview",
      method: "post",
      data: inParameter(data),
  })
      .then((res) => {
          res.data = decrypt(res.data);
          return res;
      })
      .catch((err) => {
          console.log(err);
      });
}